module.exports = __webpack_public_path__ + "img/Freedom_finance.d125ef4c.png";